import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
// Firebase
import firebase from 'firebase/app'
import 'firebaseui-ja'
import 'firebase/auth'
import 'firebaseui-ja/dist/firebaseui.css'

import './global-components'
import './vendor-components'
import App from './App.vue'
import router from './router'
import store from './store'
import { ENABLE_SEASON_FEATURE, SET_ACCOUNT } from './const/mutation-types'
// Global Filters
import toLocaleString from './filters/toLocaleString'
import { formatNumeric } from './filters/number'
import { filesize } from './filters/filesize'
import { ifnull } from './filters/ifnull'
// Services
import repositories from './repositories/RepositoryFactory'
import customerGroup from './services/customerGroup'
import dialog from './services/dialog'
import longQuery from './services/longquery'
import dummyLongQuery from './services/dummy_longquery'
import queryNotification from './services/queryNotification'
import windowResize from './services/windowResize'

import DialogUncaughtError from './components/DialogUncaughtError.vue'

// Global Styles
import './assets/variables.scss'
import './assets/style.scss'

// Vuex Mutations and Actions
import { LOAD_BASIC_MASTERS } from './const/action-types'

Vue.config.productionTip = false

// コンポーネント共通で扱うFilter登録
Vue.filter('localeString', toLocaleString)
Vue.filter('formatNumeric', formatNumeric)
Vue.filter('filesize', filesize)
Vue.filter('ifnull', ifnull)

// Error Handling
window.addEventListener('error', err => {
  // eslint-disable-next-line no-console
  console.error('Error caught in window:', err)
  let error
  if (err.error) {
    error = err.error
  }

  dialog.open(DialogUncaughtError, { err: error })
})

Vue.config.errorHandler = (err, vm, info) => {
  // eslint-disable-next-line no-console
  console.error('Error caught in Vue (err):', err, vm, info)
  // eslint-disable-next-line no-console
  console.error('Error caught in Vue (vm):', vm)
  // eslint-disable-next-line no-console
  console.error('Error caught in Vue (info):', info)

  dialog.open(DialogUncaughtError, { err, vm, info })
}

if (process.env.VUE_APP_SENTRY_DSN) {
  // https://jp.vuejs.org/v2/guide/deployment.html#%E3%83%A9%E3%83%B3%E3%82%BF%E3%82%A4%E3%83%A0%E3%82%A8%E3%83%A9%E3%83%BC%E3%81%AE%E8%BF%BD%E8%B7%A1
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true,
      }),
    ],
  })
}

const firebaseConfig = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID,
}

firebase.initializeApp(firebaseConfig);

firebase.auth().onAuthStateChanged(user => {
  if (user) {
    store.commit(SET_ACCOUNT, {userId: user.uid})
    // 遊びなので消しても大丈夫です。
    try {
      store.commit(ENABLE_SEASON_FEATURE, !!sessionStorage.getItem('enableSeasonFeature'))
    } catch (error) {}
  }
  loadVue()
})

async function loadVue() {
  await store.dispatch(LOAD_BASIC_MASTERS, {})

  new Vue({
    router,
    store,
    repositories,
    customerGroup,
    dialog,
    // queryNotification,
    queryNotification: process.env.VUE_APP_TMP_TAPIR_API_URL_BASE
      ? queryNotification
      : dummyLongQuery,
    longQuery: process.env.VUE_APP_TMP_TAPIR_API_URL_BASE
      ? longQuery
      : dummyLongQuery,
    windowResize,
    render: h => h(App),
  }).$mount('#app')
}
